import { handleActions } from 'redux-actions';
import Immutable from 'immutable';

const ChipUploadState = Immutable.fromJS({
  alertStyle: null,
  alertMessage: null
});

const chipUploadReducer = handleActions({
  BEFORE_UPLOAD_CHIP_DATA: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: '資料處理中，請稍後。'
    })
  },
  AFTER_UPLOAD_CHIP_DATA: (state, { payload }) => {
    return state.merge({
      alertStyle: payload.alertStyle,
      alertMessage: payload.displayMessage,
    })
  },
  CLEAN_CHIP_DATA_ALERT: (state, { payload }) => {
    return state.merge({
      alertStyle: null,
      alertMessage: null
    })
  },
}, ChipUploadState);

export default chipUploadReducer;


// WEBPACK FOOTER //
// ./src/reducers/chipUploadReducer.js